<!-- 联系我们 -->
<template>
  <div>
    <headerImg headerImgText :imgSrc="require('../../assets/contactUs/contactUsHeader.png')"></headerImg>
    <div class="card">
      <mainChangeTag></mainChangeTag>
    </div>
    <!-- 地图 -->
    <div>
      <div class="amap-page-container">
        <el-amap vid="amap" :zoom="zoom" :center="center" class="amap-demo">
          <el-amap-info-window
            :position="currentWindow.position"
            :content="currentWindow.content"
            :visible="currentWindow.visible"
            :events="currentWindow.events"
          >
            <div class="map-areat">
              迈特威视网络科技有限公司
              <p>深圳市南山区粤海街道科智西路5号科苑西25栋3段506室</p>
            </div>
          </el-amap-info-window>
        </el-amap>
      </div>
    </div>
  </div>
</template>

<script>
import headerImg from "../../components/headerImg";
import { AMapManager } from "vue-amap";
import mainChangeTag from "./contactUsCompoment/mainChangeTag";

export default {
  components: {
    headerImg,
    mainChangeTag
  },
  data() {
    return {
      zoom: 17,
      center: [113.944679,22.54528],
      windows: [
        {
          position: [113.944679,22.54528],
          content: "Hi! I am here!",
          visible: true,
          events: {
            close() {
              console.log("close infowindow1");
            }
          }
        },
        {
          position: [113.944679,22.54528],
          content: "Hi! I am here too!",
          visible: true,
          events: {
            close() {
              console.log("close infowindow2");
            }
          }
        }
      ],
      slotWindow: {
        position: [113.944679,22.54528]
      },
      currentWindow: {
        position: [0, 0],
        content: "",
        events: {},
        visible: false
      }
    };
  },

  mounted() {
    window.scrollTo(0, 0);
    this.currentWindow = this.windows[0];
  },

  methods: {}
};
</script>
<style scoped>
.amap-demo {
  margin: 5% 15% 5% 15%;
  width: 70%;
  height: 400px;
}
.card {
  width: 100%;
  display: flex;
  justify-content: center;
}
.map-areat {
  color: #f40;
  font-weight: 500;
}
.map-areat p {
  color: #888;
  padding: 0;
  margin: 0;
  font-size: 12px;
}
</style>